(() => {
  if (!('customElements' in window) || customElements.get('bp-collection-worlds')) return;

  class BPCollectionWorlds extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._nav = this.querySelector('.bp-collection-worlds__nav');
      this._glass = this.querySelector('[data-bp-world-glass]');
      this._links = [...this.querySelectorAll('[data-bp-world-link]')];
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._forcedColors = window.matchMedia('(forced-colors: active)');
      if (!this._nav || !this._glass || this._links.length !== 3) return;

      this._nav.addEventListener('click', event => this._onClick(event), {signal: this._abort.signal});
      window.addEventListener('resize', () => this._syncPosition(), {signal: this._abort.signal});
      document.addEventListener('shopify:section:load', event => {
        if (event.target === this || event.target?.contains(this)) this._syncPosition();
      }, {signal: this._abort.signal});
      this._reducedMotion.addEventListener?.('change', () => {
        if (this._navigationHref) this._navigate();
        else this._syncPosition();
      }, {signal: this._abort.signal});
      if ('ResizeObserver' in window) {
        this._observer = new ResizeObserver(() => this._syncPosition());
        this._observer.observe(this._nav);
      }
      this._syncPosition();
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
      this._observer?.disconnect();
      this._observer = null;
      window.clearTimeout(this._compressTimer);
      window.clearTimeout(this._navigationTimer);
      this._navigationHref = null;
    }

    _selectedLink() {
      return this._links.find(link => link.dataset.bpWorldLink === this.dataset.currentWorld);
    }

    _positionFor(link) {
      return link.offsetLeft + (link.offsetWidth - this._glass.offsetWidth) / 2;
    }

    _syncPosition() {
      if (!this.isConnected || !this._glass || this._navigationHref) return;
      const selected = this._selectedLink();
      if (!selected) return;
      this._glass.style.transition = 'none';
      this._glass.style.setProperty('--bp-cw-x', `${this._positionFor(selected)}px`);
      this._glass.style.setProperty('--bp-cw-scale', '1');
      void this._glass.offsetWidth;
      this._glass.style.removeProperty('transition');
    }

    _onClick(event) {
      const link = event.target.closest?.('[data-bp-world-link]');
      if (!link || !this._nav.contains(link) || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') ||
        (link.target && link.target !== '_self') || this._navigationHref) return;
      if (link.dataset.bpWorldLink === this.dataset.currentWorld || this._reducedMotion.matches ||
        this._forcedColors.matches || !this._glass) return;
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;

      event.preventDefault();
      this._navigationHref = link.href;
      this._glass.style.transitionDuration = '70ms';
      this._glass.style.setProperty('--bp-cw-scale', '.82');
      this._compressTimer = window.setTimeout(() => {
        this._glass.style.transitionDuration = '230ms';
        this._glass.style.setProperty('--bp-cw-x', `${this._positionFor(link)}px`);
        this._glass.style.setProperty('--bp-cw-scale', '1');
      }, 70);
      this._navigationTimer = window.setTimeout(() => this._navigate(), 330);
    }

    _navigate() {
      if (!this._navigationHref) return;
      const href = this._navigationHref;
      this._navigationHref = null;
      window.clearTimeout(this._compressTimer);
      window.clearTimeout(this._navigationTimer);
      window.location.assign(href);
    }
  }

  customElements.define('bp-collection-worlds', BPCollectionWorlds);
})();
